import { api } from './api';

const qs = (params = {}) => {
  const q = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v != null && v !== '') q.append(k, String(v));
  });
  const s = q.toString();
  return s ? `?${s}` : '';
};

export const chequesApi = {
  // Cheque books
  createBook: (body) =>
    api.post('/cheques/books', body),

  listBooks: (params = {}) =>
    api.get(`/cheques/books${qs(params)}`),

  deactivateBook: (id) =>
    api.patch(`/cheques/books/${id}/deactivate`, {}),

  // Cheques
  issue: (body) =>
    api.post('/cheques', body),

  update: (id, body) =>
    api.patch(`/cheques/${id}`, body),

  list: (params = {}) =>
    api.get(`/cheques${qs(params)}`),

  get: (id) =>
    api.get(`/cheques/${id}`),
};
